import React, { useEffect, useState } from 'react';

const RebrandingNotification = () => {
  const [countdown, setCountdown] = useState(10);

  useEffect(() => {
    // Get the new URL based on environment
    const oldDomain = window.location.hostname;
    const newUrl = getNewUrl(oldDomain);

    // Countdown timer
    const timer = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          // Set flag to prevent showing rebranding page again
          sessionStorage.setItem('rebrandingShown', 'true');
          // Redirect to new URL
          setTimeout(() => {
            window.location.href = newUrl;
          }, 100);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const getNewUrl = (oldDomain) => {
    // Map old domains to new domains
    const urlMap = {
      'care.uat.zipdrug.com': 'https://uat.care.carecontrol.carelonrx.com/#/signin',
      'care.zipdrug-staging.com': 'https://stage.care.carecontrol.carelonrx.com/#/signin',
      'care.zipdrug.com': 'https://care.carecontrol.carelonrx.com/#/signin',
      'localhost': 'http://localhost:3001/#/signin', // For local development
    };

    return urlMap[oldDomain] || 'https://uat.care.carecontrol.carelonrx.com/#/signin';
  };

  const handleRedirectNow = () => {
    const oldDomain = window.location.hostname;
    const newUrl = getNewUrl(oldDomain);
    // Set flag to prevent showing rebranding page again
    sessionStorage.setItem('rebrandingShown', 'true');
    window.location.href = newUrl;
  };

  return (
    <div style={styles.pageWrapper}>
      <div style={styles.container}>
        <div style={styles.logo}>
          <img 
            src="/images/carecontrol-logo.png" 
            alt="CareControl Logo" 
            style={styles.logoImage}
            onError={(e) => {
              // Fallback if image doesn't exist
              e.target.style.display = 'none';
            }}
          />
        </div>
        
        <h1 style={styles.heading}>We're Rebranding!</h1>
        
        <div style={styles.content}>
          <p style={styles.message}>
            <strong>ZipDrug</strong> is now <strong style={styles.highlight}>Care Control</strong>
          </p>
          
          <p style={styles.description}>
            We're excited to announce that ZipDrug has been rebranded to Care Control 
            by CarelonRx. This change reflects our continued commitment to providing 
            exceptional care coordination services.
          </p>

          <div style={styles.urlBox}>
            <p style={styles.urlLabel}>New URL:</p>
            <p style={styles.newUrl}>
              {getNewUrl(window.location.hostname)}
            </p>
          </div>

          <p style={styles.redirectMessage}>
            You will be automatically redirected to the new login page in{' '}
            <strong style={styles.countdown}>{countdown}</strong> seconds...
          </p>

          <div style={styles.spinnerContainer}>
            <div style={styles.spinner}></div>
          </div>
          <style>
            {`
              @keyframes spin {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
              }
            `}
          </style>

          <button 
            onClick={handleRedirectNow}
            style={styles.button}
          >
            Redirect Now
          </button>

          <p style={styles.bookmarkNote}>
            Please update your bookmarks with the new URL.
          </p>
        </div>
      </div>
    </div>
  );
};

const styles = {
  pageWrapper: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#F5F5F5',
    fontFamily: 'Elevance Sans, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  },
  container: {
    textAlign: 'center',
    padding: '40px 20px',
    maxWidth: '600px',
    margin: '0 auto',
    backgroundColor: 'white',
    borderRadius: '8px',
    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
  },
  logo: {
    marginBottom: '30px',
  },
  logoImage: {
    maxWidth: '200px',
    height: 'auto',
  },
  heading: {
    fontSize: '2.6rem',
    fontWeight: '500',
    color: '#231E33',
    marginBottom: '20px',
    fontFamily: 'Elevance Sans, sans-serif',
  },
  content: {
    fontSize: '16px',
    lineHeight: '1.6',
    color: '#231E33',
  },
  message: {
    fontSize: '20px',
    marginBottom: '20px',
    color: '#231E33',
  },
  highlight: {
    color: '#5009B5',
    fontSize: '22px',
    fontWeight: '600',
  },
  description: {
    marginBottom: '30px',
    fontSize: '16px',
    color: '#231E33',
  },
  urlBox: {
    backgroundColor: '#EBE4FF',
    border: '2px solid #5009B5',
    borderRadius: '8px',
    padding: '20px',
    marginBottom: '30px',
  },
  urlLabel: {
    fontSize: '14px',
    fontWeight: '600',
    color: '#231E33',
    marginBottom: '10px',
  },
  newUrl: {
    fontSize: '16px',
    fontWeight: '600',
    color: '#5009B5',
    wordBreak: 'break-all',
  },
  redirectMessage: {
    fontSize: '18px',
    marginBottom: '20px',
    color: '#231E33',
  },
  countdown: {
    color: '#5009B5',
    fontSize: '24px',
    fontWeight: '600',
  },
  spinnerContainer: {
    margin: '20px 0',
    display: 'flex',
    justifyContent: 'center',
  },
  spinner: {
    border: '4px solid #EBE4FF',
    borderTop: '4px solid #5009B5',
    borderRadius: '50%',
    width: '40px',
    height: '40px',
    animation: 'spin 1s linear infinite',
  },
  button: {
    backgroundColor: '#5009B5',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    padding: '12px 30px',
    fontSize: '16px',
    fontWeight: '600',
    cursor: 'pointer',
    marginTop: '10px',
    transition: 'background-color 0.3s',
    fontFamily: 'Elevance Sans, sans-serif',
  },
  bookmarkNote: {
    fontSize: '14px',
    color: '#231E33',
    marginTop: '30px',
    fontStyle: 'italic',
    opacity: 0.7,
  },
};

export default RebrandingNotification;
